import React from "react";
import PlayPage from "../PlayPage";
import Navbar from "../Navbar";

import Footer from "../Footer";

const Play = () => {
  return (
    <>
      <Navbar />
      <PlayPage />
      <Footer />
    </>
  );
};

export default Play;
